import {ErrorModel} from '../../../models';
import {DAO_CODE} from './_daoCode';
import axios from 'axios';
import {URL} from '../../root';
import {dailyRate} from './defaultResponseModel/dailyRate';
const FUNCTION_CODE = 'GET_ALL_ADMIN_DASHBOARD_DAILY_RATE';

export async function getDailyRate(userToken: string, params: string) {
    try {
        const response = await axios.get(
            `${URL}/dashboards/partner/daily-rate/${params}`,
            {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Token ${userToken}`
                }
            },
        );

        return dailyRate.from(response.data);
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
